import React, { useState, useEffect } from "react";



import { Link } from "react-router-dom";
import db from "./Firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function UsersCourseData() {
    const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState("");
    const [enrolledStudents, setEnrolledStudents] = useState([]);
    const [maxLessons, setMaxLessons] = useState(0);
    const [searchPhone, setSearchPhone] = useState(""); // Search by phone number
    const [personalDetails, setPersonalDetails] = useState({});
    const [statsMap, setStatsMap] = useState({});

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const q = query(collection(db, "nv_courses"));
                const snapshot = await getDocs(q);
                const courseList = snapshot.docs.map(doc => ({
                    id: doc.id,
                    name: doc.data().course_name
                }));
                setCourses(courseList);

            } catch (error) {
                console.error("Error fetching courses:", error);
            }
        };
        fetchCourses();
    }, []);




    // const fetchEnrolledStudents = async (courseName) => {
    //     try {
    //         const q = query(collection(db, "nv_enrolled_courses"), where("course_name", "==", courseName));
    //         const snapshot = await getDocs(q);
    //         const enrolledList = snapshot.docs.map(doc => doc.data());

    //         // Find max lessons count dynamically
    //         const maxLessonsCount = Math.max(...enrolledList.map(student => student.lessons.length), 0);
    //         setMaxLessons(maxLessonsCount);

    //         setEnrolledStudents(enrolledList);
    //         fetchPersonalDetails(enrolledList)
    //         fetchQuizStatsForCourse("005")
    //     } catch (error) {
    //         console.error("Error fetching enrolled students:", error);
    //     }
    // };

    const fetchEnrolledStudents = async (courseName) => {
        try {
            const q = query(collection(db, "nv_enrolled_courses"), where("course_name", "==", courseName));
            const snapshot = await getDocs(q);
            const enrolledList = snapshot.docs.map(doc => doc.data());

            const maxLessonsCount = Math.max(...enrolledList.map(student => student.lessons.length), 0);
            setMaxLessons(maxLessonsCount);
            setEnrolledStudents(enrolledList);
            fetchPersonalDetails(enrolledList);

            // 🔥 Get unique course_id directly from enrolledList
            const courseId = enrolledList[0]?.course_id;
            if (courseId) {
                fetchQuizStatsForCourse(courseId);
            }
        } catch (error) {
            console.error("Error fetching enrolled students:", error);
        }
    };


    async function fetchQuizStatsForCourse(courseId) {
        const q = query(collection(db, "nv_quiz_attempt"), where("course_id", "==", courseId));
        const snapshot = await getDocs(q);

        // const statsMap = {};

        snapshot.forEach((doc) => {
            const data = doc.data();
            const phone = data.phone;
            const correctAnswers = data.correct_answers || 0;
            const key = `${phone}_${courseId}`;

            if (!statsMap[key]) {
                statsMap[key] = { attempts: 1, maxMarks: correctAnswers };
            } else {
                statsMap[key].attempts += 1;
                if (correctAnswers > statsMap[key].maxMarks) {
                    statsMap[key].maxMarks = correctAnswers;
                }
            }
        });

        console.log(statsMap);
        setStatsMap(statsMap);
        return statsMap;
    }

    // **Fetch personal details for all phone numbers**
    const fetchPersonalDetails = async (courses) => {
        console.log(courses)
        const phoneNumbers = [...new Set(courses.map((course) => course.phone_no))];

        if (phoneNumbers.length === 0) return; // No phone numbers to fetch

        let detailsMap = {};
        const batchSize = 10; // Firestore 'in' query limit

        // **Fetch in batches of 10**
        for (let i = 0; i < phoneNumbers.length; i += batchSize) {
            const batch = phoneNumbers.slice(i, i + batchSize);
            const q = query(collection(db, "personal_details"), where("phone_no", "in", batch));

            const snapshot = await getDocs(q);
            snapshot.docs.forEach((doc) => {
                const d = doc.data();
                detailsMap[d.phone_no] = d.full_name || "N/A"; // Default if missing
            });
        }

        setPersonalDetails(detailsMap);
        console.log(phoneNumbers)
    };

    const calculateOverallProgress = (lessons) => {
        if (!lessons || lessons.length === 0) return "0%";
        const total = lessons.reduce((sum, lesson) => sum + parseFloat(lesson.completion_percentage), 0);
        return `${(total / lessons.length).toFixed(2)}%`;
    };

    // Filter students by phone number
    const filteredStudents = enrolledStudents.filter(student =>
        student.phone_no.includes(searchPhone)
    );

    // Export to Excel
    const downloadExcel = () => {
        const data = filteredStudents.map(student => {
            const row = {
                "Course Name": student.course_name,
                "Phone Number": student.phone_no,
            };

            student.lessons.forEach((lesson, index) => {
                row[`Class ${index + 1} (%)`] = lesson.completion_percentage || "N/A";
            });

            row["Overall (%)"] = calculateOverallProgress(student.lessons);
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Progress Report");
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(dataBlob, "Course_Progress_Report.xlsx");
    };

    return (
        <>
            <div className="p-2 d-flex justify-content-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="card-header pb-0 px-3 d-flex justify-content-between">
                <h6 className="mb-2">Course Progress Report</h6>

                {/* <button className="btn btn-success btn-sm" onClick={downloadExcel}>
                    Download Excel
                </button> */}
            </div>


            <div className="p-3">

                <div className="card-header pb-0 px-3 d-flex justify-content-between">
                    {/* <h6 className="mb-2">Course Progress Report</h6> */}
                    <div className="mb-3">
                        <label>Select Course:</label>
                        <select
                            className="form-control"
                            value={selectedCourse}
                            onChange={(e) => {
                                setSelectedCourse(e.target.value);
                                fetchEnrolledStudents(e.target.value);
                            }}
                        >
                            <option value="">-- Select Course --</option>
                            {courses.map(course => (
                                <option key={course.id} value={course.name}>
                                    {course.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    {/* Search by Phone Number */}
                    {/* <div className="mb-3">
                        <label>Search by Phone No:</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter phone number"
                            value={searchPhone}
                            onChange={(e) => setSearchPhone(e.target.value)}
                        />
                    </div> */}
                    {/* 
                    <button className="btn btn-success btn-sm" onClick={downloadExcel}>
                        Download Excel
                    </button> */}
                </div>


                {/* <div className="card-header pb-0 px-3 d-flex justify-content-between">
                    <h6 className="mb-2">Course Progress Report</h6>

    
                    <div className="mb-3">
                        <label>Select Course:</label>
                        <select
                            className="form-control"
                            value={selectedCourse}
                            onChange={(e) => {
                                setSelectedCourse(e.target.value);
                                fetchEnrolledStudents(e.target.value);
                            }}
                        >
                            <option value="">-- Select Course --</option>
                            {courses.map(course => (
                                <option key={course.id} value={course.name}>
                                    {course.name}
                                </option>
                            ))}
                        </select>
                    </div>

                  
                    <div className="mb-3">
                        <label>Search by Phone No:</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter phone number"
                            value={searchPhone}
                            onChange={(e) => setSearchPhone(e.target.value)}
                        />
                    </div>

                    <button className="btn btn-success" onClick={downloadExcel}>
                        Download Excel
                    </button>
                </div> */}

                {filteredStudents.length > 0 && (
                    <div className="table-responsive fix-width scroll-inner">
                        <table className="table table-bordered table-hover">
                            <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                                <tr>
                                    <th>#</th>
                                    <th style={{ paddingRight: "16rem" }}>Name</th>
                                    <th>Phone Number</th>
                                    {[...Array(maxLessons)].map((_, i) => (
                                        <th key={i}>Class {i + 1} (%)</th>
                                    ))}
                                    <th>Overall (%)</th>
                                    <th>Attempts</th>
                                    <th>Max Marks (%)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredStudents.map((student, index) => {
                                    const key = `${student.phone_no}_${student.course_id}`;
                                    const stats = statsMap[key] || { attempts: 0, maxMarks: 0 };
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {personalDetails[student.phone_no] || "Loading..."}
                                            <td>{student.phone_no || "N/A"}</td>

                                            {[...Array(maxLessons)].map((_, i) => (
                                                <td key={i}>
                                                    {student.lessons[i]?.completion_percentage || "N/A"}
                                                </td>
                                            ))}

                                            <td>{calculateOverallProgress(student.lessons)}</td>
                                            <td>{stats.attempts}</td>
                                            <td>{stats.maxMarks}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </>
    );
}

export default UsersCourseData;


// import React, { useState, useEffect } from "react";


// import { Link } from "react-router-dom";
// import db from "./Firebase";
// import { collection, query, where, getDocs } from "firebase/firestore";
// import Moment from "moment";
// import { extendMoment } from "moment-range";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// function UsersCourseData() {
//     const [courses, setCourses] = useState([]);
//     const [selectedCourse, setSelectedCourse] = useState("");
//     const [enrolledStudents, setEnrolledStudents] = useState([]);
//     const [maxLessons, setMaxLessons] = useState(0); // Track max number of lessons

//     useEffect(() => {
//         const fetchCourses = async () => {
//             try {
//                 const q = query(collection(db, "nv_courses"));
//                 const snapshot = await getDocs(q);
//                 const courseList = snapshot.docs.map(doc => ({
//                     id: doc.id,
//                     name: doc.data().course_name
//                 }));
//                 setCourses(courseList);
//             } catch (error) {
//                 console.error("Error fetching courses:", error);
//             }
//         };
//         fetchCourses();
//     }, []);

//     const fetchEnrolledStudents = async (courseName) => {
//         try {
//             const q = query(collection(db, "nv_enrolled_courses"), where("course_name", "==", courseName));
//             const snapshot = await getDocs(q);
//             const enrolledList = snapshot.docs.map(doc => doc.data());

//             // Find max lessons count dynamically
//             const maxLessonsCount = Math.max(...enrolledList.map(student => student.lessons.length), 0);
//             setMaxLessons(maxLessonsCount);

//             setEnrolledStudents(enrolledList);
//         } catch (error) {
//             console.error("Error fetching enrolled students:", error);
//         }
//     };

//     const calculateOverallProgress = (lessons) => {
//         if (!lessons || lessons.length === 0) return "0%";
//         const total = lessons.reduce((sum, lesson) => sum + parseFloat(lesson.completion_percentage), 0);
//         return `${(total / lessons.length).toFixed(2)}%`;
//     };



//     return (
//         <>
//             <div className="p-2 d-flex justify-content-between">
//                 <Link to="/">
//                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
//                 </Link>
//             </div>

//             <div className="p-3">
//                 <div className="card-header pb-0 px-3 d-flex justify-content-between">
//                     <h6 className="mb-2">Course Progress Report</h6>

//                     {/* Course Dropdown */}
//                     <div className="mb-3">
//                         <label>Select Course:</label>
//                         <select
//                             className="form-control"
//                             value={selectedCourse}
//                             onChange={(e) => {
//                                 setSelectedCourse(e.target.value);
//                                 fetchEnrolledStudents(e.target.value);
//                             }}
//                         >
//                             <option value="">-- Select Course --</option>
//                             {courses.map(course => (
//                                 <option key={course.id} value={course.name}>
//                                     {course.name}
//                                 </option>
//                             ))}
//                         </select>
//                     </div>
//                 </div>


//                 {enrolledStudents.length > 0 && (
//                     <div className="table-responsive fix-width scroll-inner">
//                         <table className="table table-bordered table-hover">
//                             <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
//                                 <tr>
//                                     <th>Course Name</th>
//                                     <th>Phone Number</th>
//                                     {[...Array(maxLessons)].map((_, i) => (
//                                         <th key={i}>Class {i + 1} (%)</th>
//                                     ))}
//                                     <th>Overall (%)</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {enrolledStudents.map((student, index) => (
//                                     <tr key={index}>
//                                         <td>{student.course_name || "N/A"}</td>
//                                         <td>{student.phone_no || "N/A"}</td>

//                                         {/* Individual Class Completion Percentages */}
//                                         {[...Array(maxLessons)].map((_, i) => (
//                                             <td key={i}>
//                                                 {student.lessons[i]?.completion_percentage || "N/A"}
//                                             </td>
//                                         ))}

//                                         {/* Overall Completion Percentage */}
//                                         <td>{calculateOverallProgress(student.lessons)}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 )}

//             </div>
//         </>
//     );
// }

// export default UsersCourseData;

// // import React, { useState, useEffect } from "react";


// // import { collection, getDocs, query, where } from "firebase/firestore";
// // import db from "./Firebase";

// // const UsersCourseData = () => {
// //     const [courses, setCourses] = useState([]);
// //     const [selectedCourse, setSelectedCourse] = useState("");
// //     const [enrolledStudents, setEnrolledStudents] = useState([]);
// //     const [maxLessons, setMaxLessons] = useState(0); // Track max number of lessons

// //     useEffect(() => {
// //         const fetchCourses = async () => {
// //             try {
// //                 const q = query(collection(db, "nv_courses"));
// //                 const snapshot = await getDocs(q);
// //                 const courseList = snapshot.docs.map(doc => ({
// //                     id: doc.id,
// //                     name: doc.data().course_name
// //                 }));
// //                 setCourses(courseList);
// //             } catch (error) {
// //                 console.error("Error fetching courses:", error);
// //             }
// //         };
// //         fetchCourses();
// //     }, []);

// //     const fetchEnrolledStudents = async (courseName) => {
// //         try {
// //             const q = query(collection(db, "nv_enrolled_courses"), where("course_name", "==", courseName));
// //             const snapshot = await getDocs(q);
// //             const enrolledList = snapshot.docs.map(doc => doc.data());

// //             // Find max lessons count dynamically
// //             const maxLessonsCount = Math.max(...enrolledList.map(student => student.lessons.length), 0);
// //             setMaxLessons(maxLessonsCount);

// //             setEnrolledStudents(enrolledList);
// //         } catch (error) {
// //             console.error("Error fetching enrolled students:", error);
// //         }
// //     };

// //     const calculateOverallProgress = (lessons) => {
// //         if (!lessons || lessons.length === 0) return "0%";
// //         const total = lessons.reduce((sum, lesson) => sum + parseFloat(lesson.completion_percentage), 0);
// //         return `${(total / lessons.length).toFixed(2)}%`;
// //     };

// //     return (
// //         <div className="container mt-4">
// //             <h4>Course Progress Report</h4>

// //             {/* Course Dropdown */}
// //             <div className="mb-3">
// //                 <label>Select Course:</label>
// //                 <select
// //                     className="form-control"
// //                     value={selectedCourse}
// //                     onChange={(e) => {
// //                         setSelectedCourse(e.target.value);
// //                         fetchEnrolledStudents(e.target.value);
// //                     }}
// //                 >
// //                     <option value="">-- Select Course --</option>
// //                     {courses.map(course => (
// //                         <option key={course.id} value={course.name}>
// //                             {course.name}
// //                         </option>
// //                     ))}
// //                 </select>
// //             </div>

// //             {/* Enrolled Students Table */}
// //             {enrolledStudents.length > 0 && (
// //                 <div className="table-responsive">
// //                     <table className="table table-bordered">
// //                         <thead className="thead-dark">
// //                             <tr>
// //                                 <th>Course Name</th>
// //                                 <th>Phone Number</th>
// //                                 {[...Array(maxLessons)].map((_, i) => (
// //                                     <th key={i}>Class {i + 1} (%)</th>
// //                                 ))}
// //                                 <th>Overall (%)</th>
// //                             </tr>
// //                         </thead>
// //                         <tbody>
// //                             {enrolledStudents.map((student, index) => (
// //                                 <tr key={index}>
// //                                     <td>{student.course_name || "N/A"}</td>
// //                                     <td>{student.phone_no || "N/A"}</td>

// //                                     {/* Individual Class Completion Percentages */}
// //                                     {[...Array(maxLessons)].map((_, i) => (
// //                                         <td key={i}>
// //                                             {student.lessons[i]?.completion_percentage || "N/A"}
// //                                         </td>
// //                                     ))}

// //                                     {/* Overall Completion Percentage */}
// //                                     <td>{calculateOverallProgress(student.lessons)}</td>
// //                                 </tr>
// //                             ))}
// //                         </tbody>
// //                     </table>
// //                 </div>
// //             )}
// //         </div>
// //     );
// // };

// // export default UsersCourseData;


// // // import React, { useState, useEffect } from "react";


// // // import { collection, getDocs, query, where } from "firebase/firestore";
// // // import db from "./Firebase";

// // // const UsersCourseData = () => {
// // //     const [courses, setCourses] = useState([]);
// // //     const [selectedCourse, setSelectedCourse] = useState("");
// // //     const [enrolledStudents, setEnrolledStudents] = useState([]);

// // //     // Fetch all courses for the dropdown
// // //     useEffect(() => {
// // //         const fetchCourses = async () => {
// // //             try {
// // //                 const q = query(collection(db, "nv_courses"));
// // //                 const snapshot = await getDocs(q);

// // //                 const courseList = snapshot.docs.map(doc => ({
// // //                     id: doc.id,
// // //                     name: doc.data().course_name
// // //                 }));

// // //                 setCourses(courseList);
// // //             } catch (error) {
// // //                 console.error("Error fetching courses:", error);
// // //             }
// // //         };

// // //         fetchCourses();
// // //     }, []);

// // //     // Fetch enrolled students when a course is selected
// // //     const fetchEnrolledStudents = async (courseName) => {
// // //         try {
// // //             const q = query(collection(db, "nv_enrolled_courses"), where("course_name", "==", courseName));
// // //             const snapshot = await getDocs(q);

// // //             const enrolledList = snapshot.docs.map(doc => doc.data());

// // //             setEnrolledStudents(enrolledList);
// // //         } catch (error) {
// // //             console.error("Error fetching enrolled students:", error);
// // //         }
// // //     };

// // //     return (
// // //         <div className="container mt-4">
// // //             <h4>Course Enrollment</h4>

// // //             {/* Course Dropdown */}
// // //             <div className="mb-3">
// // //                 <label>Select Course:</label>
// // //                 <select
// // //                     className="form-control"
// // //                     value={selectedCourse}
// // //                     onChange={(e) => {
// // //                         setSelectedCourse(e.target.value);
// // //                         fetchEnrolledStudents(e.target.value);
// // //                     }}
// // //                 >
// // //                     <option value="">-- Select Course --</option>
// // //                     {courses.map(course => (
// // //                         <option key={course.id} value={course.name}>
// // //                             {course.name}
// // //                         </option>
// // //                     ))}
// // //                 </select>
// // //             </div>

// // //             {/* Enrolled Students Table */}
// // //             {enrolledStudents.length > 0 && (
// // //                 <div className="table-responsive">
// // //                     <table className="table table-bordered">
// // //                         <thead className="thead-dark">
// // //                             <tr>
// // //                                 <th>Course Name</th>
// // //                                 <th>Phone Number</th>
// // //                             </tr>
// // //                         </thead>
// // //                         <tbody>
// // //                             {enrolledStudents.map((student, index) => (
// // //                                 <tr key={index}>
// // //                                     <td>{student.course_name || "N/A"}</td>
// // //                                     <td>{student.phone_no || "N/A"}</td>
// // //                                 </tr>
// // //                             ))}
// // //                         </tbody>
// // //                     </table>
// // //                 </div>
// // //             )}
// // //         </div>
// // //     );
// // // };

// // // export default UsersCourseData;